module.exports = __webpack_public_path__ + "portal/static/img/krungsri.8f1c2f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/krungsri.png
// module id = Inod
// module chunks = 67